module.exports = __webpack_public_path__ + "img/sprite.bb73e0bd.svg";